import reducer from './reducers';

export { default as resourceSelectors } from './selectors';
export { default as resourceOperations } from './operations';
export { default as resourceTypes } from './types';

export default reducer;
